import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {
  Box,
  ButtonBase,
  CardMedia,
  Chip,
  Drawer,
  FormControl,
  FormControlLabel,
  FormGroup,
  Input,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  Select,
  Slider,
  Switch,
  TextField,
} from "@material-ui/core";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import MsgObjetoCreado from "../../../componentes/MsgObjetoCreado";
import axios from "../../../helpers/API";
import { useFormik } from "formik";
import * as Yup from "yup";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ListaTransferencia from "../../../componentes/ListaTransferencia";
import MsgGenericoAlerta from "componentes/MsgGenericoAlerta";

const useStyles = makeStyles((theme) => ({
  cardCrear: {
    height: 120,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
  inputNuevaBanda: {
    width: "100%",
  },
}));

function RolesForm(props) {
  const classes = useStyles();
  const [usuarios, setUsuarios] = React.useState([]);
  const [roles, setRoles] = React.useState([]);
  const [permisos, setPermisos] = React.useState([]);
  const [creado, setCreado] = React.useState(false);
  const [rolEdit, setRolEdit] = React.useState(false);

  //PERMISOS, ROLES, GRUPOS -> MODAL
  const [modalListaPermisos, setModalListaPermisos] = React.useState(false);
  const [modalListaRoles, setModalListaRoles] = React.useState(false);
  const [modalListaUsuarios, setModalListaUsuarios] = React.useState(false);

  // MODALS
  const [modalExito, setModalExito] = useState(false);
  const [msgExito, setMsgExito] = useState("");
  const [tituloExito, setTituloExito] = useState("");

  useEffect(() => {
    getPermisos();
    getUsuarios();

    if (props.editando)
      axios
        .post("/seguridad/rol/obtener", { id: props.editando.id })
        .then(function (response) {
          if (!response.data.error) {
            setRolEdit(response.data);
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
  }, []);

  const getUsuarios = () => {
    axios
      .post("/seguridad/usuarios/listarPorEtiqueta", {})
      .then(function (response) {
        if (!response.data.error) {
          setUsuarios(response.data);
        } else {
          //   updateMessage(response.data.msg, true);
        }
      })
      .catch(function (error) {
        console.log(error);
        // updateMessage("Ha ocurrido un error al traer roles", true);
      });
  };

  const getPermisos = () => {
    axios
      .post("/seguridad/permisos/listarPorEtiqueta", {})
      .then(function (response) {
        if (!response.data.error) {
          setPermisos(response.data);
        } else {
          //   updateMessage(response.data.msg, true);
        }
      })
      .catch(function (error) {
        console.log(error);
        // updateMessage("Ha ocurrido un error al traer permisos", true);
      });
  };

  const updatePermisos = (permisos_) => {
    getPermisos();
    formik.setFieldValue("permisos", permisos_);
  };

  const updateUsuarios = (usuarios_) => {
    getUsuarios();
    formik.setFieldValue("usuarios", usuarios_);
  };

  const cargarRol = (values) => {
    if (rolEdit) {
      values.id = rolEdit.id;
    }

    values.permisos = values.permisos.map((permiso) => {
      return permiso.value;
    });
    values.usuarios = values.usuarios.map((usuario) => {
      return usuario.value;
    });
    console.log(values);
    axios
      .post(rolEdit ? "/seguridad/rol/editar" : "/seguridad/rol/nuevo",values)
      .then(function (response) {
        if (!response.data.error) {
          setCreado(true);
          props.getRoles()
        } else {
          setModalExito(true);
          setMsgExito("Ocurrio un Error");
          setTituloExito("Editar Usuario");
        }
      })
      .catch(function (error) { });
  };

  const validationSchema = Yup.object({
    nombre: Yup.string().required("Campo obligatorio"),
  });

  const formik = useFormik({
    initialValues: {
      id: rolEdit ? rolEdit.userId : null,
      activado: rolEdit ? rolEdit.activado : false,
      nombre: rolEdit ? rolEdit.nombre : "",
      usuarios: rolEdit ? rolEdit.usuarios : [],
      permisos: rolEdit ? rolEdit.permisos : [],
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(JSON.stringify(values, null, 2));
      cargarRol(values);
    },
  });

  return (
    <div
      style={{
        margin: "20px",
        maxWidth: "20vw",
        width: "20vw",
      }}
    >
      {creado && (
        <MsgObjetoCreado
          msg={
            "El rol ha sido " +
            (rolEdit ? "actualizado" : "creado") +
            " correctamente"
          }
          setCreado={setCreado}
          drawer={props.drawer}
        />
      )}
      <form onSubmit={formik.handleSubmit}>
        <Box>
        <Typography variant="h5">{rolEdit ? "Datos del " : "Nuevo " }Rol</Typography>
        </Box>
        <Box mt={2}>
          <FormControlLabel
            mt={10}
            control={
              <Switch
                checked={formik.values.activado}
                onChange={formik.handleChange}
                id="activado"
                name="activado"
              />
            }
            label="Activo"
          />
        </Box>
        
        <Box mt={1}>
          <TextField
            variant="outlined"
            className={classes.inputNuevaBanda}
            value={formik.values.nombre}
            id="nombre"
            name="nombre"
            onChange={formik.handleChange}
            label="Rol"
            type="text"
            error={formik.errors.nombre && formik.touched.nombre}
            helperText={formik.errors.nombre && formik.errors.nombre}
          />
        </Box>
        <Box mt={1}>
          <FormControl variant="outlined" className={classes.inputNuevaBanda}>
            <Button variant="outlined" onClick={() => setModalListaUsuarios(true)}>
              Usuarios Asignados({formik.values.usuarios.length})
            </Button>
            <Dialog
              onClose={() => setModalListaUsuarios(false)}
              aria-labelledby="simple-dialog-title"
              open={modalListaUsuarios}
              maxWidth={"lg"}
              fullWidth={true}
            >
              <DialogContent>
                <ListaTransferencia
                  open={setModalListaUsuarios}
                  listaNueva={updateUsuarios}
                  listaAsignada={formik.values.usuarios}
                  listaTotal={() => {
                    const opciones = usuarios;
                    formik.values.usuarios.forEach((optAsignada) => {
                      let index = opciones.findIndex((opt) => {
                        if (opt.value == optAsignada.value) {
                          return true;
                        }
                      });
                      if (index != -1) {
                        opciones.splice(index, 1);
                      }
                    });
                    return opciones;
                  }}
                />
              </DialogContent>
            </Dialog>
          </FormControl>
        </Box>

        <Box mt={1}>
          <FormControl variant="outlined" className={classes.inputNuevaBanda}>
            <Button
              variant="outlined"
              onClick={() => setModalListaPermisos(true)}
            >
              Permisos asignados({formik.values.permisos.length})
            </Button>
            <Dialog
              onClose={() => setModalListaPermisos(false)}
              aria-labelledby="simple-dialog-title"
              open={modalListaPermisos}
              maxWidth={"lg"}
              fullWidth={true}
            >
              <DialogContent>
                <ListaTransferencia
                  open={setModalListaPermisos}
                  listaNueva={updatePermisos}
                  listaAsignada={formik.values.permisos}
                  listaTotal={() => {
                    const opciones = permisos;
                    formik.values.permisos.forEach((optAsignada) => {
                      let index = opciones.findIndex((opt) => {
                        if (opt.value == optAsignada.value) {
                          return true;
                        }
                      });
                      if (index != -1) {
                        opciones.splice(index, 1);
                      }
                    });
                    return opciones;
                  }}
                />
              </DialogContent>
            </Dialog>
          </FormControl>
        </Box>
        <Box mt={3} style={{ float: "right" }}>
          <Button variant="contained" color="secondary" type="submit">
            {rolEdit ? "Actualizar" : "Crear"}
          </Button>
        </Box>
      </form>
    </div>
  );
}
export default RolesForm;
